"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disablePropsSDKFactory = void 0;
const disablePropsSDKFactory = ({ setProps, props }) => ({
    get enabled() {
        return typeof props.isDisabled !== 'undefined' ? !props.isDisabled : true;
    },
    disable: () => {
        setProps({ isDisabled: true });
        return Promise.resolve();
    },
    enable: () => {
        setProps({ isDisabled: false });
        return Promise.resolve();
    },
});
exports.disablePropsSDKFactory = disablePropsSDKFactory;
//# sourceMappingURL=disablePropsSDKFactory.js.map